import { Flex, Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  title: string;
  description: string;
  onSelect: () => void;
};

export const SourceTypeCard = ({ title, description, onSelect }: Props) => {
  return (
    <Flex
      bg="gray.1"
      style={{ borderRadius: '16px', cursor: 'pointer' }}
      py="sm"
      px="md"
      justify="space-between"
      align="center"
      onClick={onSelect}
    >
      <Stack gap="xxxs">
        <Text size="textSm" fw={FONT_WEIGHTS.semibold} c="gray.10">
          {title}
        </Text>
        <Text size="textXs" fw={FONT_WEIGHTS.regular} c="gray.10">
          {description}
        </Text>
      </Stack>
      <Text size="textSm" fw={FONT_WEIGHTS.semibold} c="brand.6">
        Select
      </Text>
    </Flex>
  );
};
